import React, { useState, useEffect, useContext } from "react";
import { globalInfo } from "../../App";
import { useParams, Link } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { ToastContainer, toast } from "react-toastify";
import { submitFormData } from "../../Utils/adminFunctions";
import {
  getCountriesDropdown,
  getStatesDropdowns,
} from "../../Utils/commonFunctions";
import {useNavigate } from "react-router-dom"
import { Redirect } from 'react-router-dom';

let AdminAddSite = () => {
  const { ip_address } = useContext(globalInfo);
  const { mID } = useParams();
  //for dropdowns//
  const [listCountries, setListCountries] = useState([]);
  const [listStates, setListStates] = useState([]);
  ////form input fields///
  const [siteName, setSiteName] = useState("");
  const [addressLineOne, setAddressLineOne] = useState("");
  const [addressLineTwo, setAddressLineTwo] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [errorSiteName, setErrorSiteName] = useState("");
  const [errorAddressLineOne, setErrorAddressLineOne] = useState("");
  const [errorCountry, setErrorCountry] = useState("");
  const [errorState, setErrorState] = useState("");
  const navigate = useNavigate()
  useEffect(() => {
    async function fetchAPI1() {
      const reId = "";
      const response = await getCountriesDropdown(reId);
      if (response.status == "success") {
        setListCountries(response.optionItems);
      } else {
        toast.error(response.message, { autoClose: 1500 });
      }
    }
    fetchAPI1();
  }, []);

  let getStates = (countryID) => {
    if (countryID !== "") {
      async function fetchAPI2() {
        const response = await getStatesDropdowns(countryID);
        if (response.status == "success") {
          setListStates(response.optionItems);
        } else {
          setListStates([]);
        }
      }
      fetchAPI2();
    } else {
      setListStates([]);
    }
  };

  const submitAddSite = async () => {
    let errorRequiredFiled = 0;
    if (siteName === "") {
      setErrorSiteName("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }
    if (addressLineOne === "") {
      setErrorAddressLineOne("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }

    if (country === "") {
      setErrorCountry("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }

    if (state === "") {
      setErrorState("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }

    if (errorRequiredFiled > 0) {
      toast.warning("Required fields are missing ", { autoClose: 1500 });
      return false;
    }
    const bodyFormData = new FormData();
    bodyFormData.append("site_name", siteName);
    bodyFormData.append("manufacturer_id", mID);
    bodyFormData.append("address1", addressLineOne);
    bodyFormData.append("address2", addressLineTwo);
    bodyFormData.append("country_id", country);
    bodyFormData.append("state_id", state);
    bodyFormData.append("city", city);
    bodyFormData.append("zip_code", zipCode);
    bodyFormData.append("entered_by_ip", ip_address);
    const response = await submitFormData("addSite", bodyFormData);
    if (response.status == "success") {
      setSiteName("");
      setAddressLineOne("");
      setAddressLineTwo("");
      setCountry("");
      setState("");
      setCity("");
      setZipCode("");
      setListStates([]);
      toast.success(response.message, { autoClose: 1500 });
      // window.location.href = `/AdminListSites/${mID}`;
      // navigate to previous page after success
      navigate(`/AdminListSites/${mID}`)
    } else {
      toast.error(response.message, { autoClose: 1500 });
    }
   
  };

  return (
    <div>
      <div className="wrapper">
        <div>
          <ToastContainer></ToastContainer>
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card card-default">
                      <div className="card-header">
                        <div className="card-tools">
                          <div className="col-md-12">
                            <Link
                              to={"/AdminListSites/" + mID}
                              className="btn btn-sm custom-btn-primary"
                            >
                              <i className="fa fa-arrow-left"></i> Back
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Site Name<i className="text-danger">*</i>
                              </span>
                              <input
                                type="text"
                                className={
                                  "form-control" +
                                  (errorSiteName ? " is-invalid" : "")
                                }
                                placeholder="Site Name"
                                value={siteName}
                                onChange={(e) => {
                                  setSiteName(e.target.value);
                                  setErrorSiteName("");
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Address Line-1<i className="text-danger">*</i>
                              </span>
                              <input
                                type="text"
                                className={
                                  "form-control" +
                                  (errorAddressLineOne ? " is-invalid" : "")
                                }
                                placeholder="Address Line-1"
                                value={addressLineOne}
                                onChange={(e) => {
                                  setAddressLineOne(e.target.value);
                                  setErrorAddressLineOne("");
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Address Line-2
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Address Line-2"
                                value={addressLineTwo}
                                onChange={(e) => {
                                  setAddressLineTwo(e.target.value);
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Country<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control custom-select" +
                                  (errorCountry ? " is-invalid" : "")
                                }
                                value={country}
                                onChange={(e) => {
                                  getStates(e.target.value);
                                  setCountry(e.target.value);
                                  setErrorCountry("");
                                }}
                              >
                                <option value="">Select</option>
                                {listCountries}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                State<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control custom-select" +
                                  (errorState ? " is-invalid" : "")
                                }
                                value={state}
                                onChange={(e) => {
                                  setState(e.target.value);
                                  setErrorState("");
                                }}
                              >
                                <option value="">Select</option>
                                {listStates}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                City
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="City"
                                value={city}
                                onChange={(e) => {
                                  setCity(e.target.value);
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Zip/Postal Code
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Zip/Postal Code"
                                value={zipCode}
                                onChange={(e) => {
                                  setZipCode(e.target.value);
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-md-12">
                            <button
                              type="button"
                              className="btn btn-sm custom-btn-primary pull-right"
                              onClick={submitAddSite}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminAddSite;
